import { render } from "./RelatedBookings.vue?vue&type=template&id=1617fac1"
import script from "./RelatedBookings.vue?vue&type=script&lang=js"
export * from "./RelatedBookings.vue?vue&type=script&lang=js"

import "./RelatedBookings.vue?vue&type=style&index=0&id=1617fac1&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__